<template>
  <div>
    <div class="form-group" :class="{ error: errors.email }">
      <label for="email" class="visually-hidden">{{ __TT('Email') }}</label>
      <input
        type="email"
        name="email"
        class="form-control"
        :class="{ error: errors.email || loginError.email }"
        v-model="emailInput"
        :placeholder="__TT('Email')"
      />
      <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
    </div>

    <div
      class="form-group form-group--has-view-password"
      :class="{ error: errors.password || loginError.email }"
    >
      <label for="password" class="visually-hidden">{{ __TT('Password') }}</label>
      <div>
        <input
          :type="showPassword ? 'text' : 'password'"
          name="password"
          :placeholder="__TT('Password')"
          class="form-control"
          v-model="password"
          ref="passwordInput"
        />
        <button
          class="view-password"
          :class="{ 'view-password--visible': showPassword }"
          @click.prevent="toggleShow"
          aria-label="View Password"
          type="button"
        ></button>
      </div>
    </div>

    <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
    <div v-if="loginError.email" class="invalid-feedback">{{ loginError.email[0] }}</div>
    <button @click.prevent="submitForm" id="btn_login" type="submit" class="ds-button">
      {{ __TT('Log In') }}
    </button>

    <a :href="passwordResetRoute" class="ds-hyperlink forgot-password">{{
      __TT('Forgot Your Password?')
    }}</a>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      required: false,
      type: String,
    },
    credentialsError: {
      required: false,
      type: [Object, Array],
    },
    passwordResetRoute: {
      requered: false,
      type: String,
    },
  },
  data() {
    return {
      emailInput: this.email,
      password: null,
      showPassword: false,
      loginError: this.credentialsError,
      isError: false,
      errors: null,
    };
  },
  created() {
    this.errors = this.errorFormat();
  },
  methods: {
    errorFormat() {
      return {
        email: null,
        password: null,
      };
    },

    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    submitForm() {
      this.validateForm();
      if (!this.isError) {
        const userRegistrationForm = document.getElementById('login-form');
        userRegistrationForm.submit();
      }
    },

    validateForm() {
      this.isError = false;
      this.errors = this.errorFormat();

      if (!this.emailInput.match(/^\S+@\S+\.\S+$/)) {
        this.isError = true;
        this.errors.email = this.__TT('Must be a valid email address');
      }

      if (this.emailInput == null || this.emailInput === '') {
        this.isError = true;
        this.errors.email = this.__TT('Email is required');
      }

      if (this.password == null || this.password === '') {
        this.isError = true;
        this.errors.password = this.__TT('Password is required');
      }
    },
  },
};
</script>
